
/**
 * Module dependencies.
 */

import { ComponentType, ReactNode, useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { find } from 'lodash';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  component?: ComponentType<any>;
  exact?: boolean;
  path: string;
  rules: Array<{
    external?: boolean;
    redirectTo: string;
    rule: boolean;
  }>;
};

/**
 * Export `ConditionalRoute` component.
 */

export function ConditionalRoute(props: Props): JSX.Element | null {
  const { rules, ...rest } = props;
  const history = useHistory();
  const activeRule = find(rules, 'rule');

  useEffect(() => {
    if (!activeRule) {
      return;
    }

    const { external, redirectTo } = activeRule;

    if (external) {
      window.location.href = redirectTo;
    } else {
      history.replace(redirectTo);
    }
  }, [activeRule, history, rules]);

  if (activeRule) {
    return null;
  }

  return <Route {...rest} />;
}
